import { capitalize } from "@common/helpers/string";
import { InvoiceStatus } from "@common/types/invoice";

export function getInvoiceStatusLabel(status: InvoiceStatus): string {
    if (status === InvoiceStatus.UNCOLLECTABLE) {
        return "Uncollectible";
    }
    return capitalize(status);
}
